import { render } from "./ProgramForm.vue?vue&type=template&id=3ef05a95&scoped=true"
import script from "./ProgramForm.vue?vue&type=script&lang=js"
export * from "./ProgramForm.vue?vue&type=script&lang=js"

import "./ProgramForm.vue?vue&type=style&index=0&id=3ef05a95&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef05a95"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QStepper,QStep,QInput,QBtn,QForm,QBadge});
